import React, { Component } from 'react'
import { Modal, Form, Input, Row, Col, Select, Button } from 'antd'

class userCreateModal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      error: '',
      loading: false,
      isFetching: true,
    }
  }

  handleOk = (e) => {
    e.preventDefault()

    this.setState({
      error: '',
      loading: true
    })

    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.createUser(values).then(response => {
          if (response.data.error) {
            this.setState({
              error: response.data.error.message
            })
          } else {
            this.handleCancel()
            this.props.getDivisions()
          }

          this.setState({
            loading: false
          })
        })
      } else {
        this.setState({
          loading: false
        })
      }
    })
  }

  handleCancel = (e) => {
    this.props.closeModal()
  }

  divisionFieldValidator = (rule, value, callback) => {
    const { division: { list } } = this.props

    if(value) {
      const selectedDivision = list.filter(division => division.id === Number(value))[0]

      if(selectedDivision.licenseNumber === selectedDivision.usedLicenseNumber) {
        callback('Licenses quota is reached')
      }
    } else {
      callback('Please, select a division')
    }

    callback()
  }

  render () {
    const { division: { list }, form: { getFieldDecorator } } = this.props

    return (
      <Modal
        wrapClassName='vertical-center-modal'
        title='Add a user'
        visible={this.props.status}
        destroyOnClose
        width={455}
        onCancel={this.handleCancel}
        loading={this.state.isFetching}
        footer={[
          <Button key='back' onClick={this.handleCancel}>Cancel</Button>,
          <Button key='submit' type='indigo' loading={this.state.loading} onClick={this.handleOk}>Invite</Button>
        ]}
      >

        { this.state.error.length > 0 ? <div className='form__error'>{ this.state.error }</div> : '' }

        <Form onSubmit={this.handleOk} className='form' autoComplete='new-password'>

          <Row>
            <Col span={10}>
              <div className='ant-form-item-label'>
                <label className='ant-form-item' title='Groups'>Division</label>
              </div>
            </Col>
            <Col span={14}>
              <Form.Item>
                {getFieldDecorator('divisionId', {
                  rules: [{
                    validator: this.divisionFieldValidator,
                    required: true
                  }]
                })(
                  <Select
                    allowClear
                    name='divisionId'
                    placeholder='Select Division'
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  >
                    { list.map(division => <Select.Option key={division.id.toString()}>{ division.name }</Select.Option>) }
                  </Select>
                )}
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={10}>
              <div className='ant-form-item-label'>
                <label className='ant-form-item' title='Groups'>Groups</label>
              </div>
            </Col>
            <Col span={14}>
              <Form.Item>
                {getFieldDecorator('groupIds', {
                  rules: [{
                    required: false,
                    message: 'Please select user groups',
                    type: 'array'
                  }]
                })(
                  <Select
                    mode='multiple'
                    name='groupIds'
                    placeholder='Select Groups'
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                    { this.props.group.list.map((group, index) => <Select.Option key={index} value={group.id}>{ group.name }</Select.Option>) }
                  </Select>
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <div className='ant-form-item-label'>
                <label className='ant-form-item' title='First Name'>First Name</label>
              </div>
            </Col>
            <Col span={14}>
              <Form.Item>
                {getFieldDecorator('firstName', {
                  rules: [{
                    required: true,
                    message: 'Please input user First Name',
                    max: 32,
                    pattern: /^[^ ][ a-zA-Z_\\-\\.0-9]*/
                  }]
                })(
                  <Input name='firstName' placeholder='First Name' maxLength={32} />
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <div className='ant-form-item-label'>
                <label className='ant-form-item' title='Last Name'>Last Name</label>
              </div>
            </Col>
            <Col span={14}>
              <Form.Item>
                {getFieldDecorator('lastName', {
                  rules: [{
                    required: true,
                    message: 'Please input user Last Name',
                    max: 32,
                    pattern: /^[^ ][ a-zA-Z_\\-\\.0-9]*/
                  }]
                })(
                  <Input name='lastName' placeholder='Last Name' maxLength={32} />
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <div className='ant-form-item-label'>
                <label className='ant-form-item' title='Email'>Email</label>
              </div>
            </Col>
            <Col span={14}>
              <Form.Item>
                {getFieldDecorator('email', {
                  rules: [{
                    required: true,
                    message: 'Please input user email',
                    type: 'email'
                  }]
                })(
                  <Input name='email' type='email' placeholder='Email' />
                )}
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={10}>
              <div className='ant-form-item-label'>
                <label className='ant-form-item' title='Groups'>Role</label>
              </div>
            </Col>
            <Col span={14}>
              <Form.Item>
                {getFieldDecorator('role', {
                  rules: [{
                    required: true,
                    message: 'Please select user role'
                  }]
                })(
                  <Select
                    name='role'
                    placeholder='Select Role'>
                    <Select.Option value='ORGANIZATION_ADMIN'>Administrator</Select.Option>
                    <Select.Option value='USER'>User</Select.Option>
                  </Select>
                )}
              </Form.Item>
            </Col>
          </Row>

        </Form>
      </Modal>
    )
  }
}

export default Form.create()(userCreateModal)



// WEBPACK FOOTER //
// ./src/components/Modals/UserCreateModal/UserCreateModal.jsx